import React from 'react';
import {CurrencySwitcher} from '@homeaway/react-currency-switcher';
import {CurrencyMenuItemsWrapper} from '../components/tray/currency-menu-items-wrapper/CurrencyMenuItemsWrapper';
import URLSearchParams from 'url-search-params';
import request from 'superagent';
import get from 'lodash.get';
import ConnectorContext from '../components/context/ConnectorContext';

export default class CurrencySelectorConnector extends React.Component {
    static contextType = ConnectorContext;

    getRedirectUrl = (currency) => {
        let origin = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
        let params = new URLSearchParams(window.location.search);
        /* istanbul ignore else */
        if (this.props.currencyCode !== currency) {
            params.set('cur', currency);
        }
        return `${origin}${params.toString() !== '' ? `?${params.toString()}` : ''}`;
    };

    handleChangeCurrencySelector = async (currency) => {
        /* istanbul ignore else */
        if (window && window.location) {
            const redirectUrl = this.getRedirectUrl(currency);
            const saveCurrencyVariant = get(window, '__ABACUS__.VRBO_SAVE_CURRENCY.value');
            const {dataUrl} = this.context;
            let locale = null;
            let siteUrl = null;

            if (saveCurrencyVariant) {
                if (this.props.currencyCode !== currency) {
                    await request.patch(`${dataUrl}saveCurrency`).send({currency}).type('application/json');
                }
            }

            if (this.props.onCurrencySelectorChange) {
                this.props.onCurrencySelectorChange({
                    redirectUrl,
                    locale,
                    currency,
                    siteUrl
                });
            } else {
                window.location.assign(redirectUrl);
            }
        }
    };

    render() {
        if (!this.props.currencyList) {
            return <CurrencySwitcher {...this.props} onCurrencySelectorChange={this.handleChangeCurrencySelector} />;
        }

        return (
            <CurrencyMenuItemsWrapper
                translations={this.props.translations}
                currencyList={this.props.currencyList}
                selectedCurrency={this.props.currencyCode}
                isTopCurrenciesView={this.props.isTopCurrenciesView}
                handleShowAllCurrenciesClick={this.props.handleShowAllCurrenciesClick}
                onCurrencySelectorChange={this.handleChangeCurrencySelector}
            />
        );
    }
}
